import axios from "axios";
import { endpoints } from "../_config";

class CommunityService {
  /**
   * Add Community Group Api
   * @param {*} user, new create group data
   * @returns
   */
  static async addGroup(user, data) {
    return axios
      .post(endpoints.community.add, data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get all groups of Organization
   * @param {*} Bearer token
   * @returns
   */
  static async getAllOrganizationGroups(user, orgId) {
    return axios
      .get(endpoints.community.getOrganizationGroups(orgId), {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get group details
   * @param {*} Bearer token, groupId
   * @returns
   */
  static async getGroupDetails(user, groupId) {
    return axios
      .get(endpoints.community.getGroupDetails(groupId), {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get update organization
   * @param {*} Bearer token
   * @returns
   */
  static async updateGroup(user, groupId, data) {
    return axios
      .put(endpoints.community.update(groupId), data, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Delete Group
   * @param {*} user groupId
   * @returns delted response
   */
  static async deleteGroup(user, groupId) {
    return axios
      .delete(endpoints.community.delete(groupId), {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }
}

export { CommunityService };
